import React from 'react';

/**
 * Zvýrazní text v řetězci.
 * @param search text pro zvýraznění
 * @param text řetězec
 * @return {*}
 */
export default function highlightText(search, text) {
    const searchLen = search.length;
    if (searchLen === 0) {
        return text;
    }

    const textLower = text.toLocaleLowerCase();
    const searchLower = search.toLocaleLowerCase();

    const arr = textLower.split(searchLower);
    const result = [];

    let i = 0;
    for (let a=0; a<arr.length; a++) {
        let partLen = arr[a].length;
        if (partLen > 0) {
            result.push(text.substring(i, i + partLen));
            i += partLen;
        }
        result.push(<strong>{text.substring(i, i + searchLen)}</strong>);
        i += searchLen;
    }

    return result;
}
